import React from 'react';
import { MemoryRouter, Route, Routes } from 'react-router-dom';

import { GlobalStateProvider } from './providers';
import { ConfigContext } from './contexts';

import {
  Subscription,
  SubscriptionsList,
  PaymentProfiles,
  ComponentsAllocation,
  CustomFields,
} from './pages';

import { ComponentSettings } from './types';
import { ModalsContainer } from './containers/ModalsContainer';

const App = ({
  subscription,
  paymentProfile,
  componentsAllocation,
}: ComponentSettings) => {
  return (
    <ConfigContext.Provider
      value={{ subscription, paymentProfile, componentsAllocation }}
    >
      <GlobalStateProvider>
        <MemoryRouter>
          <Routes>
            <Route path="/" element={<SubscriptionsList />} />
            <Route
              path="subscription/:catalogId/:subscriptionId"
              element={<Subscription />}
            />
            <Route
              path="paymentProfiles/:catalogId/:subscriptionId"
              element={<PaymentProfiles />}
            />
            <Route
              path="componentsAllocation/:catalogId/:subscriptionId"
              element={<ComponentsAllocation />}
            />
            <Route
              path="customFields/:catalogId/:subscriptionId"
              element={<CustomFields />}
            />
          </Routes>
          <ModalsContainer />
        </MemoryRouter>
      </GlobalStateProvider>
    </ConfigContext.Provider>
  );
};

export default App;
